import { styled } from '@nykaa/ui-components';
import {
  BASE_GUTTER_SPACE,
  DWEB_PRIMARY_HEADER_HEIGHT,
  DWEB_SECONDARY_HEADER_HEIGHT,
  PROMO_BANNER_HEIGHT,
  COLORS,
} from 'shared/styles/base';
import { fadeIn } from 'shared/styles/animations/fadeIn';

export const TitleContainer = styled.div<{ selected: boolean }>`
  height: ${DWEB_SECONDARY_HEADER_HEIGHT}px;
  padding: ${BASE_GUTTER_SPACE}px ${BASE_GUTTER_SPACE * 2}px;
  cursor: pointer;

  justify-content: center;
  align-items: center;
  display: flex;

  ${({ theme }) => theme.typography.bodyMedium}

  .icon-arrow {
    font-size: 10px;
  }

  .flipped {
    font-size: 10px;
    transform: rotate(90deg);
    transition: transform 0.2s ease;
  }

  background: ${(props) => (props.selected ? 'rgba(0, 19, 37, 0.04)' : '')};
`;

export const ContentContainer = styled.div`
  position: fixed;
  top: ${PROMO_BANNER_HEIGHT + DWEB_PRIMARY_HEADER_HEIGHT + DWEB_SECONDARY_HEADER_HEIGHT}px;
  left: 0;
  height: 100px;
  background-color: #fff;
  width: 100%;
  overflow: hidden;
  ${fadeIn};
`;

export const Icon = styled.i`
  display: inline-block;
  margin-left: ${BASE_GUTTER_SPACE}px;
  transform: rotate(270deg);
  font-size: 10px;
  cursor: pointer;
  color: ${COLORS.BLACK_100};
`;

export const Button = styled.button`
  outline: 0;
  border: 0;
  background: none;
  position: relative;
`;
